export default "<p>Bienvenue dans le module  {{module?.name || \"---\"}}</p>\n"